import type { Menu } from "@arfood/shared";
import { pickI18n } from "./render/util.ts";

export interface OrderItem {
  dish: string;
  qty: number;
}

export interface OrderController {
  add(dishId: string): void;
}

// Bestell-Intent Stufe 1: RAM-Merkliste mit Mengen, kein Zahlungsvorgang, keine PII.
// onCart meldet jede Mengenänderung (add/remove) für Analytics (cart_add/cart_remove).
export function createOrder(
  menu: Menu,
  getLang: () => string,
  onIntent: (items: OrderItem[]) => void,
  onCart: (change: "add" | "remove", dishId: string) => void,
): OrderController {
  const cart = new Map<string, number>();
  const bar = document.getElementById("order-bar");
  const items = document.getElementById("order-summary");
  const count = document.getElementById("order-count");
  const confirmBtn = document.getElementById("order-confirm");
  const status = document.getElementById("order-status");

  function dishName(id: string): string {
    const dish = menu.dishes.find((d) => d.id === id);
    return dish ? pickI18n(dish, getLang()).name : id;
  }

  function setQty(id: string, qty: number): void {
    const cur = cart.get(id) ?? 0;
    if (qty <= 0) cart.delete(id);
    else cart.set(id, qty);
    if (qty > cur) onCart("add", id);
    else if (qty < cur) onCart("remove", id);
    if (status) status.hidden = true;
    render();
  }

  function render(): void {
    if (!bar || !items) return;
    const total = [...cart.values()].reduce((a, b) => a + b, 0);
    bar.hidden = total === 0;
    if (count) count.textContent = total === 1 ? "1 Artikel" : `${total} Artikel`;
    items.replaceChildren();
    for (const [id, qty] of cart) {
      const row = document.createElement("div");
      row.className = "order-item";

      const name = document.createElement("span");
      name.className = "oi-name";
      name.textContent = dishName(id);

      const stepper = document.createElement("span");
      stepper.className = "oi-stepper";
      stepper.append(stepBtn("dec", id, "−"), qtyEl(qty), stepBtn("inc", id, "+"));

      row.append(name, stepper);
      items.appendChild(row);
    }
  }

  function stepBtn(dir: "inc" | "dec", id: string, label: string): HTMLButtonElement {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "oi-step";
    b.dataset["cart"] = dir;
    b.dataset["dish"] = id;
    b.textContent = label;
    return b;
  }
  function qtyEl(qty: number): HTMLElement {
    const s = document.createElement("span");
    s.className = "oi-qty";
    s.textContent = String(qty);
    return s;
  }

  items?.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-cart]");
    const id = btn?.dataset["dish"];
    if (!btn || !id) return;
    setQty(id, (cart.get(id) ?? 0) + (btn.dataset["cart"] === "inc" ? 1 : -1));
  });

  confirmBtn?.addEventListener("click", () => {
    if (cart.size === 0) return;
    onIntent([...cart.entries()].map(([dish, qty]) => ({ dish, qty })));
    cart.clear();
    render();
    if (status) {
      status.textContent = "Bestellung notiert — bitte dem Personal zeigen.";
      status.hidden = false;
    }
  });

  return {
    add(dishId: string): void {
      setQty(dishId, (cart.get(dishId) ?? 0) + 1);
    },
  };
}
